import { useFiltersV2Actions, useFiltersV2Store } from "PFApp/components/filters_v2";
import { hasDefaultValue, isFilterModified, isValueEmpty } from "PFCore/helpers/filters";
import { FilterKeyV2, FilterV2 } from "PFTypes/filters_v2";
import { useCallback } from "react";

export const useBufferedFilter = (filterKey: FilterKeyV2) => {
  const filter = useFiltersV2Store((state) => state.buffer.mainFilters[filterKey] as FilterV2);
  const { updateBufferedFilter } = useFiltersV2Actions();

  const update = useCallback(
    (updatedFilter: Partial<Omit<FilterV2, "name" | "originalPath">>) =>
      updateBufferedFilter({ name: filterKey, ...updatedFilter }),
    [filterKey, updateBufferedFilter]
  );

  const clear = useCallback(
    () => updateBufferedFilter({ name: filterKey, value: null }),
    [filterKey, updateBufferedFilter]
  );

  const restore = useCallback(
    () => updateBufferedFilter({ name: filterKey, value: filter.defaultValue || null }),
    [filter.defaultValue, filterKey, updateBufferedFilter]
  );

  return {
    canClear: !filter.required && !isValueEmpty(filter.value),
    canRestore: hasDefaultValue(filter) && isFilterModified(filter),
    restore,
    clear,
    update,
    filter
  };
};
